import {  Injectable }             from '@angular/core';
import { Subject } from 'rxjs/Subject';
import { CanActivateChild, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router, NavigationEnd } from '@angular/router';
import { CurrentUserService } from './shared/services/current-user.service';
import { PermissionsService } from './shared/services/permissions.service';
import { ApiService } from './root-services/api.service';

// RxJs Interfaces
import { Observable }               from 'rxjs/Observable';

@Injectable()
export class PermissionsRouteGuard implements CanActivateChild {
  constructor(
    private apiService: ApiService,
    private currentUser: CurrentUserService,
    private permissionsService: PermissionsService,
    private router: Router
  ) { }

  canActivateChild(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> {
    let parentRoutes = route.pathFromRoot;
    let i = parentRoutes.length - 1;
    let routeCursor = parentRoutes[i];
    while (routeCursor.data && !routeCursor.data.requiredRole) {
      i--;
      if (i < 0) throw new Error('Required role has to be set somewhere in parent routes');
      console.log("routeCursor", routeCursor.routeConfig.path);
      // Iterate upwards through route tree to find permissions for that tree
      routeCursor = parentRoutes[i];
      console.log("routeCursor parent", routeCursor.routeConfig.path);
    }
    let targetRequiredPermission = routeCursor.data.requiredRole;
    
    const permittedObservable = this.permissionsService.checkPermission(targetRequiredPermission);
    permittedObservable.subscribe(permitted => {
      if (!permitted) {
        this.router.navigate(['/unauthorized']);
      }
    });
    return permittedObservable;
  }
}

@Injectable()
export class AuthenticationInitializedGuard implements CanActivateChild {
  constructor(
    private apiService: ApiService
  ) { }

  canActivateChild(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean {
    // TODO: do we need to replace this with "admin identity available?"
    return true
  }
}



// WEBPACK FOOTER //
// /home/runner/work/nomadic-admin/nomadic-admin/nomadic-admin/src/app/app-guards.ts